<app-navbar></app-navbar>

<div class="login-container">
  <ng-container *ngIf="getBackgroundStyle()">
    <div class="blur-background" [ngStyle]="getBackgroundStyle()"></div>
  </ng-container>

  <app-generic-card [title]="title" [subtitle]="subtitle">
    <ng-container card-content>
      <ng-content select="[card-content]"></ng-content>
    </ng-container>
    <ng-container card-actions>
      <ng-content select="[card-actions]"></ng-content>
    </ng-container>
  </app-generic-card>
</div>
